var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSushiswap = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_45318_133182",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H1V23H23V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_45318_133182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.58337 3.1084L22.6334 14.7501L18.4167 20.9834L1.3667 9.25007L5.58337 3.1084Z",
    fill: "url(#paint0_linear_45318_133182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6332 14.7501C21.1665 16.8585 16.2165 16.0335 11.5415 12.7335C6.77485 9.52512 4.20818 5.21679 5.58318 3.10845C7.04985 1.00012 11.9998 1.82512 16.6748 5.12512C21.4415 8.24179 24.0082 12.6418 22.6332 14.7501Z",
    fill: "url(#paint1_linear_45318_133182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4166 20.8921C16.95 23.0004 12 22.1754 7.32496 18.8754C2.64996 15.5754 -0.00837681 11.3587 1.45829 9.15875C2.92496 7.05041 7.87496 7.87541 12.55 11.1754C17.225 14.4754 19.7916 18.7837 18.4166 20.8921Z",
    fill: "url(#paint2_linear_45318_133182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6333 14.75L18.4166 20.9834C16.95 23.0917 12 22.175 7.32497 18.9667C6.4083 18.325 5.5833 17.6834 4.7583 16.95C5.39997 16.8584 6.22497 16.4917 7.04997 15.575C8.51663 14.0167 9.24997 13.65 9.89163 13.7417C10.5333 13.7417 11.2666 14.3834 12.4583 15.9417C13.65 17.5 15.3 17.9584 16.3083 17.1334C16.4 17.0417 16.4916 17.0417 16.5833 16.95C17.4083 16.3084 17.6833 16.0334 19.2416 13.1C19.6083 12.3667 20.8916 11.175 22.6333 11.725C23.0916 12.9167 23.0916 13.925 22.6333 14.75Z",
    fill: "#0E0F23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9915 14.3836C20.7082 16.2169 16.2165 15.3003 11.9082 12.2753C7.50822 9.25027 4.94155 5.40027 6.22488 3.56694C7.50822 1.7336 11.9999 2.65027 16.3082 5.67527C20.6166 8.70027 23.1832 12.5503 21.9915 14.3836ZM17.9582 11.6336C17.3165 12.5503 15.1166 12.0919 12.9166 10.6253C10.8082 9.1586 9.52488 7.2336 10.1666 6.31694C10.8082 5.40027 13.0082 5.8586 15.2082 7.32527C17.3165 8.79194 18.5999 10.7169 17.9582 11.6336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21652 5.21704C5.21652 5.12537 5.12485 5.03371 5.03319 5.12537C4.94152 5.21704 4.84985 5.21704 4.84985 5.30871C4.94152 5.58371 5.03319 5.76704 5.03319 5.95037C5.03319 6.04204 5.12485 6.13371 5.21652 6.04204C5.30819 6.04204 5.39985 5.95037 5.30819 5.85871C5.30819 5.67537 5.30819 5.49204 5.21652 5.21704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6749 6.68335C5.6749 6.59168 5.58324 6.50001 5.49157 6.59168C5.3999 6.68335 5.3999 6.68335 5.3999 6.77501C6.40824 9.06668 8.51657 11.5417 11.2666 13.375C11.3582 13.4667 11.4499 13.375 11.5416 13.375C11.6332 13.2833 11.5416 13.1917 11.5416 13.1C8.6999 11.2667 6.68324 8.88335 5.6749 6.68335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7666 15.6665C16.6749 15.6665 16.5833 15.6665 16.5833 15.7582C16.5833 15.8498 16.5833 15.9415 16.6749 15.9415C16.9499 16.0332 17.3166 16.1248 17.5916 16.2165C17.6833 16.2165 17.7749 16.2165 17.7749 16.1248C17.7749 16.0332 17.7749 15.9415 17.6833 15.9415C17.4083 15.8498 17.0416 15.7582 16.7666 15.6665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4165 16.0337C18.3248 16.0337 18.2332 16.1254 18.2332 16.217C18.2332 16.3087 18.3248 16.4004 18.4165 16.4004C19.1498 16.492 19.9748 16.5837 20.6165 16.492C20.7082 16.492 20.7998 16.4004 20.7998 16.3087C20.7998 16.217 20.7082 16.1254 20.6165 16.1254C19.8832 16.217 19.1498 16.1254 18.4165 16.0337Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45318_133182",
    x1: 8.92388,
    y1: 1.45317,
    x2: 12.3051,
    y2: 13.0639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45318_133182",
    x1: 11.7082,
    y1: 0.642253,
    x2: 15.0895,
    y2: 12.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_45318_133182",
    x1: 6.14796,
    y1: 2.26184,
    x2: 9.52927,
    y2: 13.8726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSushiswap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_sushiswap.21cc3fea20b239d349c74cfab5f00490.svg";